import type {
  AvonBaseUserDto,
  AvonMedicalCenterDto,
  AvonSpecializationDto,
  TwilioIncomingPhoneNumberInstance,
  UserAdministrationDto,
  BulkUserOperationRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';
import type {
  BulkUserOperationResponseRequest,
  CreateAdministrationUserRequest,
  UpdateAdministrationUserRequest,
} from '@act/shared/types';

export const userAdministratorRequests = {
  getUsers: EndpointDefinition.get<
    UserAdministrationDto[],
    {
      roles?: string[];
      teamIds?: string[];
      clientIds?: string[];
      hasClient?: string;
    }
  >({
    name: 'getUsers',
    route: '/users/administration',
  }),
  createUser: EndpointDefinition.post<
    UserAdministrationDto,
    CreateAdministrationUserRequest,
    null
  >({
    name: 'createUser',
    route: '/users/administration',
  }),
  updateUser: EndpointDefinition.patch<
    UserAdministrationDto,
    UpdateAdministrationUserRequest,
    { userId: string }
  >({
    name: 'updateUser',
    route: '/users/administration/:userId',
  }),
  deleteUser: EndpointDefinition.delete<
    UserAdministrationDto,
    { userId: string }
  >({
    name: 'deleteUser',
    route: '/users/administration/:userId',
  }),
  getAvonSpecializations: EndpointDefinition.get<AvonSpecializationDto[], null>(
    {
      name: 'getAvonSpecializations',
      route: '/avon/admin/specializations',
    }
  ),
  getAvonMedicalCenters: EndpointDefinition.get<AvonMedicalCenterDto[], null>({
    name: 'getAvonMedicalCenters',
    route: '/avon/admin/medical-centers',
  }),
  getAvonUser: EndpointDefinition.get<AvonBaseUserDto, { avonId: string }>({
    name: 'getAvonUser',
    route: '/avon/admin/get-avon-user/:avonId',
  }),
  getAvailablePhoneNumbers: EndpointDefinition.get<
    TwilioIncomingPhoneNumberInstance[],
    { baseNumber: number }
  >({
    name: 'getAvailablePhoneNumbers',
    route: '/users/administration/phone-numbers/available',
  }),
  bulkUserOperations: EndpointDefinition.post<
    BulkUserOperationResponseRequest,
    BulkUserOperationRequestDto,
    null
  >({
    name: 'bulkUserOperations',
    route: '/users/administration/bulk-operations',
  }),
};
